
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const SubscriptionLoading: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Votre abonnement</CardTitle>
        <CardDescription>Chargement des informations...</CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center py-6">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </CardContent>
    </Card>
  );
};

export default SubscriptionLoading;
